import Tracker from './Tracker';

const appointmentOutcomeTracker = new Tracker('appointmentOutcome', {
	SET_OUTCOME: 'setOutcome',
	TAKE_ACTION: 'takeAction'
});

export default appointmentOutcomeTracker;
